import { Container } from "react-bootstrap";
import { Routes, Route } from "react-router-dom";
import {WOW} from 'wowjs/dist/wow';
import { useEffect } from 'react';

// Layout
import Layout from "./layout/Layout";

// pages
import Home from "./pages/Home";
import About from "./pages/About";
import NotFound from "./pages/NotFound";

const App = () => {
	// useEffect(() => {
	// 	window.wow = new WOW().init();


  // },[]);
  return (
    <Layout>

        <Routes>
          <Route path="/" element={<Home />} exact />
          <Route path="/amexmandalaf1" element={<About />} />
          <Route element={<NotFound />} />
        </Routes>

    </Layout>
  );
};

export default App;
